import * as React from 'react';

import MyGuide from '../../../guidance/components/MyGuide';

export default function MyGuideTab() {
    return <MyGuide />;
}
